export default {
      id: "ic_bullhorn_green-usage",
      viewBox: "0 0 50 44",
      url: "/" + "images/icons.3.109.2.svg#ic_bullhorn_green-usage",
      toString: function () {
        return this.url;
      }
    }